// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__supQA","label":"style_label__1X6Pb","large":"style_large__3ymu-","radio":"style_radio__2vNQm"};